export default __webpack_public_path__ + "static/media/single_phone.775c2693.svg";